import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "checkbox"]
  static values = {
    documentId: Number,
    userId: Number,
    nodeUid: String
  }

  connect() {
    this.csrfToken = document.querySelector("meta[name='csrf-token']")?.content
  }

  handleKeydown(event) {
    if (event.key === ' ') {
      event.preventDefault()
      const checkbox = event.currentTarget.querySelector('.diagnosis-checkbox')
      if (checkbox) {
        checkbox.checked = !checkbox.checked
        this.toggle({ target: checkbox })
      }
    }
  }

  toggle(event) {
    const checkbox = event.target
    const diagnosisItem = checkbox.closest(".diagnosis-item")
    const diagnosisUid = diagnosisItem.dataset.diagnosisUid
    const isChecked = checkbox.checked

    if (isChecked) {
      diagnosisItem.classList.add("selected")
    } else {
      diagnosisItem.classList.remove("selected")
    }

    diagnosisItem.setAttribute('aria-checked', isChecked)

    this.saveDiagnosis(diagnosisUid, isChecked, diagnosisItem)
  }

  saveDiagnosis(diagnosisUid, isSelected, diagnosisItem) {
    const csrfToken = document.querySelector("[name='csrf-token']")?.content
    const diagnosisText = diagnosisItem.querySelector(".diagnosis-text")?.textContent

    fetch(`/api/documents/${this.documentIdValue}/toggle_diagnosis`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        user_id: this.userIdValue,
        diagnosis_uid: diagnosisUid,
        is_selected: isSelected,
        diagnosis_text: diagnosisText
      })
    })
      .then((response) => {
        if (response.ok) {
          this.dispatch("diagnosisToggled", {
            detail: {
              diagnosisUid: diagnosisUid,
              isSelected: isSelected,
              diagnosisText: diagnosisText
            }
          })
        } else {
          console.error("Failed to save diagnosis")
          const checkbox = diagnosisItem.querySelector(".diagnosis-checkbox")
          if (checkbox) {
            checkbox.checked = !isSelected
            if (isSelected) {
              diagnosisItem.classList.add("selected")
            } else {
              diagnosisItem.classList.remove("selected")
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error saving diagnosis:", error)
      })
  }
}
